<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>folder</md-icon>
                    </div>
                    <h4 class="title"></h4>
                    <div style="text-align: right">
                        <md-button
                            class="md-primary md-sm"
                            style="margin: 20px 20px 0 20px"
                            @click.native="editOpen()"
                        >
                            Adicionar
                        </md-button>
                        <md-button
                            class="md-just-icon md-simple"
                            style="float:right; margin: 10px 0 0 0"
                            @click.native="handleColumnsEdit()"
                        >
                            <md-icon>settings</md-icon>
                        </md-button>
                        <div style="float: right;">
                            <md-field>
                                <md-input
                                    type="search"
                                    clearable
                                    style="width: 200px"
                                    placeholder="Filtrar"
                                    v-model="searchQuery"
                                >
                                </md-input>
                            </md-field>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-table
                        :value="queriedData.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        class="paginated-table table-striped table-hover"
                    >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                            >
                                {{ item[column] }}
                            </md-table-cell>
                            <md-table-cell md-label="Ações">
                                <md-button
                                    class="md-just-icon md-primary md-simple"
                                    @click="viewOpen(item)"
                                >
                                    <md-icon>open_in_browser</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-warning md-simple"
                                    @click="editOpen(item)"
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-danger md-simple"
                                    @click.native="handleDelete(item)"
                                >
                                    <md-icon>close</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            {{ this.queriedData.results.length }} itens de um
                            total de {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>

        <modal v-if="viewModal" @close="viewCancel()">
            <template slot="header">
                <h4 class="modal-title">Detalhes</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="viewCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-small-size-100 md-size-100"
                        v-for="field in Object.keys(showColumns)"
                        :key="field"
                    >
                        <b>{{ columnNames[field] }}:</b>
                        {{ editModalModel[field] }}
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="viewCancel()">
                    Fechar
                </md-button>
            </template>
        </modal>

        <form @submit.prevent="editSubmit()">
            <modal v-if="editModal" @close="editCancel()">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFields"
                            :key="field"
                        >
                            <md-field
                                v-if="fieldTypes[field] != 'datetime-local'"
                            >
                                <label>{{ columnNames[field] }}</label>
                                <md-input
                                    v-model="editModalModel[field]"
                                    :type="fieldTypes[field]"
                                ></md-input>
                            </md-field>
                            <md-datepicker
                                v-model="editModalModel[field]"
                                v-else
                                md-immediately
                            >
                                <label>{{ columnNames[field] }}</label>
                            </md-datepicker>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="editCancel()">
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Pagination, Modal } from '@/components'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'

import { Stock as Model } from '@/models/stock.model'
const model = 'stock'

export default {
    created() {
        this.readEntities()
    },
    components: {
        Pagination,
        Modal
    },
    computed: {
        ...mapState({
            queriedData: state => state[model].page
        }),
        to() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[
                    this.queriedData.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[0].id
            else return 0
        },
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        }
    },
    data() {
        return {
            viewModal: false,
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            columnsModal: false,
            showColumns: Model.visibleFields,
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields),
            fieldTypes: Model.fieldTypes,
            currentSort: 'id',
            currentSortOrder: 'asc',
            searchQuery: '',
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            }
        }
    },
    methods: {
        ...mapActions(model, {
            createEntity: 'create',
            readEntities: 'read',
            updateEntity: 'update',
            deleteEntity: 'delete'
        }),
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },
        columnsCancel() {
            this.columnsModal = false
        },

        viewOpen(item) {
            this.editModalModel = { ...this.editModalModel, ...item }
            this.viewModal = true
        },
        viewCancel() {
            this.viewModal = false
            this.editModalModel = new Model()
        },

        editOpen(item) {
            if (item) {
                this.editModalTitle = 'Editando #' + item.id

                this.editModalModel = { ...this.editModalModel, ...item } // copy object values
            } else {
                this.editModalTitle = 'Novo registro'
            }
            this.editModal = true
        },
        editCancel() {
            this.editModal = false
            this.editModalModel = new Model()
        },
        async editSubmit() {
            let editError

            if (this.editModalModel.id) {
                editError = await this.updateEntity({
                    ...this.editModalModel
                })
            } else {
                editError = await this.createEntity({
                    ...this.editModalModel
                })
            }

            if (editError)
                this.$notify({
                    message:
                        'Erro ao ' +
                        (this.editModalModel.id ? 'editar' : 'criar') +
                        ' o registro.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message:
                        'Registro ' +
                        (this.editModalModel.id ? 'editado' : 'criado') +
                        ' com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })

                this.editModal = false
                this.editModalModel = new Model()
                this.readEntities()
            }
        },

        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteEntity({ id: item.id })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readEntities()
                    }
                }
            })
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                this.readEntities({ page: val.currentPage })
            },
            deep: true
        }
    }
}
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
.modal-wrapper .md-checkbox {
    display: flex !important;
}
.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
